export var TileMode;
(function (TileMode) {
    TileMode["SMALL"] = "small";
    TileMode["LARGE"] = "large";
    TileMode["LIST"] = "list";
})(TileMode || (TileMode = {}));
//# sourceMappingURL=TileMode.js.map